import Swiper from "swiper";
import {TweenMax} from "gsap";
import {TimelineMax} from "gsap";
import ScrollMagic from "scrollmagic";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
const controller = new ScrollMagic.Controller;
/**
 * TOP
 * @constructor
 */
class Top {
  constructor() {}
  /**
   * コモン
   */
  init() {
    
    //top business アニメーション
    const top_business = new TimelineMax();
    top_business.from('.p-top__business-ttl', 0.3, {
      opacity: '0',
      transform: 'translateX(-50px)',
    })
    .from('.p-top__business-subttl', 0.3, {
      opacity: '0',
      transform: 'translateX(-50px)',
    },'-=0.20')
    .from('.p-top__business-txt', 0.3, {
      opacity: '0',
    },'-=0.00')
    .from('.p-top__business-link', 0.3, {
      opacity: '0',
    },'-=0.20')
    new ScrollMagic.Scene({
      triggerElement: '.p-top__business-inner',
      triggerHook: '0.5',
      offset: '0',
      duration: '0',
      reverse: false,
    })
    .setTween(top_business)
    // .addIndicators({name: "top_business"})
    .addTo(controller);
    
    //top about アニメーション
    const top_about = new TimelineMax();
    top_about.from('.p-top__about-ttl', 0.3, {
      opacity: '0',
      transform: 'translateX(-50px)',
    })
    .from('.p-top__about-subttl', 0.3, {
      opacity: '0',
      transform: 'translateX(-50px)',
    },'-=0.20')
    .staggerFrom('.p-top__about-block-inner', 0.3, {
      opacity: '0',
      transform: 'translateY(50px)',
    }, 0.1, )
    new ScrollMagic.Scene({
      triggerElement: '.p-top__about',
      triggerHook: '0.5',
      offset: '-100',
      duration: '0',
      reverse: false,
    })
    .setTween(top_about)
//    .addIndicators({name: "top_about"})
    .addTo(controller);
    
    //top news アニメーション
    const top_news = new TimelineMax();
    top_news.from('.p-top__news-ttl', 0.3, {
      opacity: '0',
      transform: 'translateX(-50px)',
    })
    .from('.p-top__news-subttl', 0.3, {
      opacity: '0',
      transform: 'translateX(-50px)',
    },'-=0.20')
    .from('.p-top__news-tab', 0.3, {
      opacity: '0',
    })
    .staggerFrom('.p-top__news-list-item', 0.3, {
      opacity: '0',
      transform: 'translateY(50px)',
    }, 0.1, )
    .from('.p-top__news-btn', 0.3, {
      opacity: '0',
    },'-=0.20')
    new ScrollMagic.Scene({
      triggerElement: '.p-top__news-inner',
      triggerHook: '0.5',
      offset: '0',
      duration: '0',
      reverse: false,
    })
    .setTween(top_news)
//    .addIndicators({name: "top_news"})
    .addTo(controller);
    
    //top recruit アニメーション
    const top_recruit = new TimelineMax();
    top_recruit.from('.p-top__recruit-ttl', 0.3, {
      opacity: '0',
      transform: 'translateX(50px)',
    })
    .from('.p-top__recruit-subttl', 0.3, {
      opacity: '0',
      transform: 'translateX(50px)',
    },'-=0.20')
    .from('.p-top__recruit-txt', 0.3, {
      opacity: '0',
    },'-=0.00')
    .from('.p-top__recruit-btn', 0.3, {
      opacity: '0',
    },'-=0.20')
    new ScrollMagic.Scene({
      triggerElement: '.p-top__recruit',
      triggerHook: '0.5',
      offset: '0',
      duration: '0',
      reverse: false,
    })
    .setTween(top_recruit)
//    .addIndicators({name: "top_recruit"})
    .addTo(controller);

    
    //top　ニュースのタブ切り替え
    $('.js-news-tab').click(function() {
      var index = $('.p-top__news-tab-item').index(this);
      $('.p-top__news-tab-item,.p-top__news-list').removeClass('is-active');
      $(this).addClass('is-active');
      $('.p-top__news-list').eq(index).addClass('is-active');
    });
    
    document.addEventListener('DOMContentLoaded', function() {
      if($('main').hasClass('l-main--top')){
        $('.l-header').removeClass('under');
      } else {
        $('.l-header').addClass('under');
      }
    });
    
  }
}

export default Top;